angular.module("events")

    .controller("EventsGuestsImportCtrl", ['event', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state) {

            $scope.people = $stateParams.people;
            $scope.event_id = $stateParams.id;
            $scope.menu_item_id = $stateParams.menu_item_id;

    }]);